"use client";
import { useCallback } from "react";
import isEmpty from "lodash/isEmpty";

import { useLazyQuery } from "@stadium/services/apollo-client";
import { fetchBaseTotalProducts } from "@stadium/hooks/graphql/search/queries/products/fetch-total-base-products";

import { getProductRangeInputFormErrors } from "@stadium/helpers/src/product/utils";

const defaultArr = [];

const useFetchTotalBaseProductCount = ({
  showVariantsAsProducts = false,
  storeParentId,
  storeId,
  commonShopVariables,
  syncedToEs,
  storeCloneId,
  allMenuTaxonIds,
  anyMenuWithSwag,
}) => {
  const [getTotalBaseProductsCount, { data, loading }] = useLazyQuery(fetchBaseTotalProducts, {
    fetchPolicy: "cache-and-network",
  });

  const getVariables = useCallback(
    ({ minPrice, maxPrice }) => {
      return {
        storeId: storeParentId,
        designedStoreIds: [storeId],
        countryCode: "",
        taxonIds: allMenuTaxonIds,
        page: 1,
        perPage: 1,
        sortBy: "recommended",
        dietaryRestrictionIds: defaultArr,
        color: defaultArr,
        size: defaultArr,
        brandIds: defaultArr,
        skipWarehouse: !syncedToEs && !!storeCloneId,
        skipAggregations: true,
        searchQuery: "",
        withSwag: anyMenuWithSwag,
        withOutOfStock: true,
        globalZone: false,
        showVariantsAsProducts,
        includeInactiveProducts: true,
        includeInactiveVariants: true,
        ...commonShopVariables,
        priceKeys: [`${minPrice}_${maxPrice}`],
        excludeByoProducts: true,
        bulkAvailable: false,
      };
    },
    [
      storeParentId,
      storeId,
      allMenuTaxonIds,
      syncedToEs,
      storeCloneId,
      anyMenuWithSwag,
      showVariantsAsProducts,
      commonShopVariables,
    ],
  );

  const getTotalProductCount = useCallback(
    ({ minPrice, maxPrice }) => {
      if (
        isEmpty(getProductRangeInputFormErrors({ minPrice, maxPrice })) &&
        minPrice !== "" &&
        maxPrice !== "" &&
        allMenuTaxonIds?.length > 0
      ) {
        getTotalBaseProductsCount({ variables: getVariables({ minPrice, maxPrice }) });
      }
    },
    [getVariables],
  );

  return {
    totalProductsCount: data?.baseSearch?.total || 0,
    loadingProductCount: loading || typeof data?.baseSearch?.total === "undefined",
    getTotalProductCount,
    taxonLoaded: allMenuTaxonIds.length > 0,
  };
};

export default useFetchTotalBaseProductCount;
